// extracted by mini-css-extract-plugin
module.exports = {"card":"theme_card__nu9ww","head":"theme_head__u5R3V","content":"theme_content__pXUl3","foot":"theme_foot__4sDxM"};